import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import persistStore from 'redux-persist/lib/persistStore';
import { HelmetProvider } from 'react-helmet-async';

import '@/config/i18n';
import { store } from '@/store';
import { setupInterceptors } from '@/api/axios-instance';
import { setupInterceptors as setupInterceptorsV3 } from '@/api/axios.instance.V3';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import 'react-resizable/css/styles.css';
import '@/index.css';
import { GlobalStyle } from '@/styles/GlobalStyle';
import { registerYupMethods } from '@/config/yup-methods';
import { fixBootstrapError } from '@/config/other';

const persistor = persistStore(store);
setupInterceptors(store);
setupInterceptorsV3(store);
registerYupMethods();
fixBootstrapError();

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <GlobalStyle />
          <App />
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
